var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('v-overlay',{attrs:{"value":_vm.active,"opacity":"0.9"}},[_c('div',{staticClass:"text-center"},[(_vm.message)?_c('div',{staticClass:"mb-3"},[_vm._v(_vm._s(_vm.message))]):_vm._e(),_c('v-progress-circular',{attrs:{"indeterminate":"","size":"75"}})],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }